export default __webpack_public_path__ + "static/media/calculator-icon.5382ef56.svg";